import { render, staticRenderFns } from "./BrickOctagonBase.vue?vue&type=template&id=27f2ff9d&scoped=true&"
import script from "./BrickOctagonBase.vue?vue&type=script&lang=js&"
export * from "./BrickOctagonBase.vue?vue&type=script&lang=js&"
import style0 from "./BrickOctagonBase.vue?vue&type=style&index=0&id=27f2ff9d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f2ff9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27f2ff9d')) {
      api.createRecord('27f2ff9d', component.options)
    } else {
      api.reload('27f2ff9d', component.options)
    }
    module.hot.accept("./BrickOctagonBase.vue?vue&type=template&id=27f2ff9d&scoped=true&", function () {
      api.rerender('27f2ff9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Patterns/BrickOctagonBase.vue"
export default component.exports